/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedAddress           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditAddress          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * AddressDisplay: customer display component
*/

/* Imports */
import { t } from "../../../i18n";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
import { formatAddressLabel } from "./formatAddressLabel";
/***/

/*
* AddressDisplay: customer display component
* Used to display a customer entity
*/

export interface AddressDisplayProps extends GenericDisplayProps {
  address: EasyTech.Address,
  zone?: EasyTech.Zone
}

class AddressDisplay extends GenericDisplay<AddressDisplayProps> {
  getData = (() => {
    return (
      <>
        { formatAddressLabel(this.props.address) }

        {this.props.zone &&
          " "+t("common:zone")+"-"+this.props.zone.type
        }
      </>
    );
  });
}

export default AddressDisplay;
/***/